import {
  Container,
  Content,
  StyleEquipamentInfo,
  StyleMaintenanceInfo,
  StyledBoxBorder,
  StyledBoxContent,
  StyledBoxLeft,
  StyledClientInfo,
  StyledLocationBox,
  StyledLocationLogo,
  StyledLocationLogoContainer,
  StyledPreventiveMaintenance,
} from '../styled';

const Ambiente = ({ data }) => {
  return (
    <Container>
      <Content>
        <StyledBoxBorder>
          <StyledLocationLogoContainer>
            <StyledLocationLogo src={data.client.image} alt="Logo Cliente" />
          </StyledLocationLogoContainer>
          <StyledClientInfo>
            <div>
              <h2>{data.client.name}</h2>
              <h3>Saiba mais</h3>
            </div>
            <h4>Endereço</h4>
            <p>{data.client.address}</p>
            <h4>Telefone</h4>
            <p>{data.client.phone}</p>
          </StyledClientInfo>
          <StyleEquipamentInfo>
            <h2>Equipamento</h2>
            <div>
              <span></span>
              <span>
                <h3>Nome do equipamento</h3>
                <p>{data.equipment.name}</p>
                <h3>TAG</h3>
                <p>{data.equipment.tag}</p>
                <h3>Sistema</h3>
                <p>{data.equipment.system}</p>
              </span>
            </div>
          </StyleEquipamentInfo>
          <StyleMaintenanceInfo>
            <h2>Manutenção</h2>
            <h3>Possui ocorrências em aberto?</h3>
            <p>{data.maintenance.openOcurrence}</p>
            <h3>
              Tem Atividades Preventivas realizadas nos <br /> últimos 30 dias?
            </h3>
            <p>{data.maintenance.openPreventive}</p>
            <button>
              ABRIR SOLICITAÇÃO <span>(Em breve)</span>
            </button>
          </StyleMaintenanceInfo>
        </StyledBoxBorder>
        <StyledBoxLeft>
          <StyledBoxContent>
            <div>
              <span>
                <h2>Especificações do Ambiente</h2>
                <h3>Quantidade de Equipamentos</h3>
                <p>{data.environment.equipmentQuantity}</p>
                <h3>Área (m2)</h3>
                <p>{data.environment.area}</p>
              </span>
              <span>
                <h2>Dados do Ambiente Climatizado</h2>
                <h3>Tipo de Atividade</h3>
                <p>{data.environment.activityType}</p>
                <div>
                  <span>
                    <h3>Área Climatizada</h3>
                    <p>{data.environment.climatizedArea}</p>
                  </span>
                  <span>
                    <h3>Carga Térmica</h3>
                    <p>{data.environment.thermalLoad}</p>
                  </span>
                </div>
                <div>
                  <span>
                    <h3>Nº de Ocupantes Fixos</h3>
                    <p>{data.environment.fixedOcupantsNumber}</p>
                  </span>
                  <span>
                    <h3>Nº de Ocupantes Flutuantes</h3>
                    <p>{data.environment.floatingOcupantsNumber}</p>
                  </span>
                </div>
              </span>
            </div>
          </StyledBoxContent>
          <StyledLocationBox>
            <h2>Local</h2>
            <h3>Unidade de manutenção</h3>
            <p>{data.location.maintenanceUnit}</p>
            <h3>Grupo de Áreas</h3>
            <p>{data.location.areaGroup}</p>
            <h3>Subgrupo de Áreas</h3>
            <p>{data.location.areaSubgroup}</p>
          </StyledLocationBox>
          <StyledPreventiveMaintenance>
            <div>
              <span className="firstSpan">
                <h2>Maximize a eficiência em manutenção preventiva</h2>
                <p>Descubra como a Leankeep pode revolucionar sua gestão de manutenção preventiva.</p>
                <button>Saiba mais</button>
              </span>
              <span className="secondSpan"></span>
            </div>
          </StyledPreventiveMaintenance>
        </StyledBoxLeft>
      </Content>
    </Container>
  );
};

export default Ambiente;
